import React from "react";
import OrderMain from "../Order";

const ReplaceOrder = () => {
  return <OrderMain module="replace-order" title="Replace Order" />;
};

export default ReplaceOrder;
